import React from 'react';

export function Star () {
  return (
    <svg
      width={36}
      height={36}
      fill="#e7822a"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="65.688 57.927 345.46 368.622"
    >
      <path d="M143.94 426.441c-10.817.074-19.66-9.622-19.728-21.705 0-.746 0-1.492.068-2.238l8.707-105.245-62.311-78.915c-7.211-9.025-6.53-22.824 1.565-30.879 2.517-2.462 5.51-4.252 8.775-5.072l92.242-23.272 48.366-90.551c5.578-10.368 17.619-13.724 26.869-7.533 2.789 1.864 5.034 4.4 6.735 7.533l48.366 90.551 92.242 23.272c10.544 2.61 17.21 14.321 14.829 26.106-.748 3.654-2.312 7.011-4.49 9.771l-62.31 79.064 8.707 105.244c1.02 12.009-6.87 22.675-17.619 23.869-3.333.373-6.666-.224-9.727-1.716l-86.801-41.769-86.799 41.769c-2.449 1.119-5.034 1.716-7.686 1.716Zm94.004-43.612c-2.721 5.147-7.205-43.732-7.205-43.732a17.906 17.906 0 0 1 15.374 0l64.351 30.955-6.462-77.871c-.476-6.042 1.292-11.934 4.83-16.484l46.12-58.701-68.364-17.156c-5.17-1.342-9.66-5.072-12.313-10.144l-35.85-67.279-.481 260.412Z" />
    </svg>
  );
}
